// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.information-container {
  padding: 20px;
  text-align: start;
  font-size: 15px;
}

.information li{
  margin-bottom: 15px;
}
.information {
  border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  white-space: pre-line
}

#dark .information {
  /* background-color: #1b202d; */
  /* background: transparent; */
  background-color: #49555c17;

  color: rgb(211, 203, 203);
}

#light .information {
  background-color: #dad8d8;
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Information/Information.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB;AACF;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;;EAE3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".information-container {\n  padding: 20px;\n  text-align: start;\n  font-size: 15px;\n}\n\n.information li{\n  margin-bottom: 15px;\n}\n.information {\n  border-radius: 10px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-right: 10px;\n  white-space: pre-line\n}\n\n#dark .information {\n  /* background-color: #1b202d; */\n  /* background: transparent; */\n  background-color: #49555c17;\n\n  color: rgb(211, 203, 203);\n}\n\n#light .information {\n  background-color: #dad8d8;\n  color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
